/**
 * murals — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const muralsPack: ToilePack = {
    slug: 'murals',
    category: 'mural',
    name: 'Murals',
    tagline: tagline('murals', 'walls', 'techniques'),
    chips: chips('walls', 'techniques'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'jungle', label: 'Jungle wall', subject: 'a living-room jungle wall, monstera and banana leaves, a hidden toucan'},
        {key: 'office', label: 'Geometric wall', subject: 'an office wall of overlapping arcs, circles and triangles'},
        {key: 'kids', label: 'Kids-room clouds', subject: 'a kids-room wall, rolling clouds, a hot-air balloon and a paper plane'},
    ],
    styles: [
        {key: 'flat', label: 'Painted flat', style: 'painted flat, crisp hand-painted edges', palette: 'solid opaque blocks, no gradients', framing: 'wall straight on, even daylight'},
        {key: 'spray', label: 'Gradient spray', style: 'gradient spray, airbrushed transitions', palette: 'luminous blends, soft overspray', framing: 'wall straight on, even daylight'},
        {key: 'line', label: 'Single line', style: 'single continuous line drawing', palette: 'one black line on a plain wall', framing: 'wall straight on, even daylight'},
    ],
    directions: ['an ocean wave wall instead', 'in a dark moody palette', 'smaller, above the sofa only'],
}
